/**
 * Regex collection for different regions.
 */
const REGIONS = { EU: /\-euc1/ };

export const isEuRegion = REGIONS.EU.test(window.location.hostname);

export default REGIONS;
